import React, { createContext, useState, useContext, useEffect, useMemo } from 'react';
const PageContext = createContext(null);
export const PageProvider = ({ children }) => {
    const [currentPage, setCurrentPage] = useState(() => localStorage.getItem('currentPage'));
    const [currentPageName, setCurrentPageName] = useState(() => localStorage.getItem('currentPageName'));
    const [previousPage, setPreviousPage] = useState(() => localStorage.getItem('previousPage'));
    const [previousPageName, setPreviousPageName] = useState(() => localStorage.getItem('previousPageName'));
    const updatePage = (newPage, newPageName) => {
        if (!newPage || currentPage === newPage) {
            return;
        }
        setPreviousPage(currentPage);
        setPreviousPageName(currentPageName);
        setCurrentPage(newPage);
        setCurrentPageName(newPageName);
    };
    useEffect(() => {
        localStorage.setItem('currentPage', currentPage);
    }, [currentPage]);
    useEffect(() => {
        localStorage.setItem('currentPageName', currentPageName);
    }, [currentPageName]);
    useEffect(() => {
        localStorage.setItem('previousPage', previousPage);
    }, [previousPage]);
    useEffect(() => {
        localStorage.setItem('previousPageName', previousPageName);
    }, [previousPageName]);
    const value = useMemo(() => ({
        currentPage,
        currentPageName,
        previousPage,
        previousPageName,
        updatePage,
    }), [currentPage, currentPageName, previousPage, previousPageName]);
    return React.createElement(PageContext.Provider, { "data-testid": "PageContextProvider-318f4a82", value: value }, children);
};
export const usePageContext = () => useContext(PageContext);
export const withPageContext = (Component) => {
    return function WrapperComponent(props) {
        return ((React.createElement(PageContext.Consumer, { "data-testid": "PageContextProvider-8c744444" }, (context) => React.createElement(Component, Object.assign({}, props, { pageContext: context })))));
    };
};
